import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card, Empty } from "./bits";

export const AuditLog = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/audit", { params: { limit: 300 } }).then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return <Empty>Loading…</Empty>;
  return (
    <Card className="mt-4" title="Audit log" sub="Read-only. Logins, password changes and resets, admin actions (roles, plans, user creation, reseed, feature flags, support replies)." testId="audit-log">
      {!rows.length ? <Empty>No entries yet.</Empty> : <div style={{ maxHeight: 560, overflowY: "auto" }}><table className="tbl" data-testid="audit-table"><thead><tr><th>When (UTC)</th><th>Actor</th><th>Action</th><th>Target</th><th>IP</th></tr></thead>
        <tbody>{rows.map((r, i) => <tr key={i} data-testid="audit-row"><td className="mono">{(r.at || "").slice(0, 19).replace("T", " ")}</td><td>{r.actor}</td><td><span className="tag info">{r.action}</span></td><td className="mono" style={{ fontSize: ".78rem" }}>{r.target}</td><td className="mono" style={{ fontSize: ".78rem" }}>{r.ip || "—"}</td></tr>)}</tbody></table></div>}
    </Card>
  );
};
